// extracted by mini-css-extract-plugin
module.exports = {"step":"step-3RDEW","text":"text-3MPVq","icon":"icon-1lWh5"};